module.exports = __webpack_public_path__ + "static/media/mobile_green_dots_container.a53443be.png";